import { combineReducers } from 'redux';
import MarketplaceMatchesGridCreate from './MarketplaceMatchesGrid/MarketplaceMatchesGridCreate';

import {
  EDIT_TEXT_INPUT,
  GET_GEOGRAPHIES_ERROR,
  GET_GEOGRAPHIES_INIT,
  GET_GEOGRAPHIES_SUCCESS,
  GET_INDUSTRIES_ERROR,
  GET_INDUSTRIES_INIT,
  GET_INDUSTRIES_SUCCESS,
  GET_PREFERENCES_ERROR,
  GET_PREFERENCES_INIT,
  GET_PREFERENCES_SUCCESS,
  SAVE_PREFERENCES_ERROR,
  SAVE_PREFERENCES_INIT,
  SAVE_PREFERENCES_SUCCESS,
  TOGGLE_INPUT,
  TOGGLE_ITEM,
  GET_MARKETPLACE_MATCHES_START,
  GET_MARKETPLACE_MATCHES_SUCCESS,
  GET_MARKETPLACE_MATCHES_ERROR,
  GET_SURVEY_DETAILS_START,
  GET_SURVEY_DETAILS_SUCCESS,
  GET_SURVEY_DETAILS_ERROR,
  RESET_MARKETPLACE_MATCHES,
  TOGGLE_ONLY_SHOW_FREQUENT,
  PURCHASE_SUBMIT_START,
  PURCHASE_SUBMIT_SUCCESS,
  PURCHASE_SUBMIT_ERROR,
  PURCHASE_SUBMIT_RESET,
  SET_SELECTED_SLIDEOUT_JOBS,
  CLEAR_SELECTED_SLIDEOUT_JOBS,
  CHANGE_SLIDEOUT_JOB,
  TOGGLE_ACTIVE_SURVEYS,
  SET_VISIBLE_SURVEYS_COUNT,
  SET_SLIDEOUT_SEARCH_TEXT,
  SET_JOB_STATUS
} from './MarketplaceMatchesActions';

const initialState = {
  error: null,
  geographies: {
    error: null,
    loaded: false,
    loading: false,
    options: []
  },
  industries: {
    error: null,
    loaded: false,
    loading: false,
    options: []
  },
  preferences: {
    error: null,
    loaded: false,
    loading: false
  },
  savePreferences: {
    error: null,
    loaded: false,
    loading: false
  },
  settings: {
    geographies: [],
    industries: [],
    minCompany: null,
    minEmployee: null,
    minMatchLikelihood: 30,
    showNotPurchasedSurveys: true,
    showPurchasedSurveys: true,
    onlyShowFrequent: false
  },
  showMinCompanyError: false,
  showMinEmployeeError: false,
  matches: {
    purchased: null,
    unpurchased: null,
    loading: false,
    purchasedLoaded: false,
    unpurchasedLoaded: false,
    status: null,
    error: null
  },
  surveyDetails: {
    surveyJobs: [],
    filteredSurveyJobs: [],
    details: null,
    loading: false,
    loaded: false,
    status: null,
    error: null
  },
  purchaseSubmit: {
    loading: false,
    success: false,
    error: null
  },
  slideout: {
    selectedJobIds: [],
    jobs: [],
    currentJobIndex: 0,
    showActiveSurveys: true,
    activeVisibleSurveysCount: null,
    suggestedVisibleSurveysCount: null,
    searchText: ''
  }
};

function marketplaceMatchesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SELECTED_SLIDEOUT_JOBS: {
      return {
        ...state,
        slideout: {
          ...state.slideout,
          currentJobIndex: action.startingJobIndex,
          selectedJobIds: action.selectedJobIds,
          activeVisibleSurveysCount: null,
          suggestedVisibleSurveysCount: null,
          jobs: action.jobs
        }
      };
    }
    case CLEAR_SELECTED_SLIDEOUT_JOBS: {
      return {
        ...state,
        slideout: {
          currentJobIndex: 0,
          selectedJobIds: [],
          jobs: null,
          activeVisibleSurveysCount: null,
          suggestedVisibleSurveysCount: null
        }
      };
    }
    case CHANGE_SLIDEOUT_JOB: {
      const { currentJobIndex, selectedJobIds } = state.slideout;
      const { nextOrPrevious } = action;
      if (
        (currentJobIndex === 0 && nextOrPrevious === 'previous') ||
        (currentJobIndex === selectedJobIds.length - 1 && nextOrPrevious === 'next')
      ) {
        return state;
      }
      let newJobIndex;
      if (nextOrPrevious === 'previous')
        currentJobIndex === 0
          ? (newJobIndex = state.slideout.selectedJobIds.length - 1)
          : (newJobIndex = currentJobIndex - 1);
      if (nextOrPrevious === 'next')
        currentJobIndex === state.slideout.selectedJobIds.length - 1
          ? (newJobIndex = 0)
          : (newJobIndex = currentJobIndex + 1);
      return {
        ...state,
        matches: {
          ...state.matches,
          // Need to set loading to true to prevent placeholder text to flash
          loading:
            state.slideout.showActiveSurveys && !state.matches.purchasedLoaded
              ? true
              : !state.slideout.showActiveSurveys && !state.matches.unpurchasedLoaded
              ? true
              : state.matches.loading
        },
        slideout: {
          ...state.slideout,
          currentJobIndex: newJobIndex,
          activeVisibleSurveysCount: null,
          suggestedVisibleSurveysCount: null,
          searchText: ''
        }
      };
    }
    case SET_VISIBLE_SURVEYS_COUNT: {
      return {
        ...state,
        slideout: {
          ...state.slideout,
          activeVisibleSurveysCount: state.slideout.showActiveSurveys
            ? action.payload
            : state.slideout.activeVisibleSurveysCount,
          suggestedVisibleSurveysCount: !state.slideout.showActiveSurveys
            ? action.payload
            : state.slideout.suggestedVisibleSurveysCount
        }
      };
    }
    case TOGGLE_ACTIVE_SURVEYS: {
      return {
        ...state,
        slideout: {
          ...state.slideout,
          showActiveSurveys: action.active
        },
        matches: {
          ...state.matches,
          // Need to set loading to true to prevent placeholder text to flash
          loading:
            action.active && !state.matches.purchasedLoaded
              ? true
              : !action.active && !state.matches.unpurchasedLoaded
              ? true
              : state.matches.loading
        }
      };
    }
    case SET_SLIDEOUT_SEARCH_TEXT: {
      return {
        ...state,
        slideout: {
          ...state.slideout,
          searchText: action.payload
        }
      };
    }
    case SET_JOB_STATUS: {
      return {
        ...state,
        slideout: {
          ...state.slideout,
          jobs: state.slideout.jobs.map((job, index) => {
            if (index !== state.slideout.currentJobIndex) return job;
            return {
              ...job,
              status: action.payload
            };
          })
        }
      };
    }
    case EDIT_TEXT_INPUT: {
      const errorDataType = action.data.dataType === 'minEmployee' ? 'showMinEmployeeError' : 'showMinCompanyError';
      const eventInt = action.data.event === '' ? null : parseInt(action.data.event);
      const maxInputValue = 999999;
      const minInputValue = 0;
      const minInputCheck = eventInt <= minInputValue && eventInt !== null;
      const maxInputCheck = maxInputValue && eventInt > maxInputValue;

      return {
        ...state,
        settings: {
          ...state.settings,
          [action.data.dataType]: eventInt
        },
        [errorDataType]: minInputCheck || maxInputCheck
      };
    }
    case GET_GEOGRAPHIES_ERROR: {
      return {
        ...state,
        geographies: {
          ...state.geographies,
          error: action.error,
          loaded: true,
          loading: false
        }
      };
    }
    case GET_GEOGRAPHIES_INIT: {
      return {
        ...state,
        geographies: {
          ...state.geographies,
          loaded: false,
          loading: true
        }
      };
    }
    case GET_GEOGRAPHIES_SUCCESS: {
      return {
        ...state,
        geographies: {
          ...state.geographies,
          loaded: true,
          loading: false,
          options: action.data
        }
      };
    }
    case GET_INDUSTRIES_ERROR: {
      return {
        ...state,
        industries: {
          ...state.industries,
          error: action.error,
          loaded: true,
          loading: false
        }
      };
    }
    case GET_INDUSTRIES_INIT: {
      return {
        ...state,
        industries: {
          ...state.industries,
          loaded: false,
          loading: true
        }
      };
    }
    case GET_INDUSTRIES_SUCCESS: {
      return {
        ...state,
        industries: {
          ...state.industries,
          loaded: true,
          loading: false,
          options: action.data
        }
      };
    }
    case GET_PREFERENCES_ERROR: {
      return {
        ...state,
        preferences: {
          loaded: true,
          loading: false,
          error: action.error
        }
      };
    }
    case GET_PREFERENCES_INIT: {
      return {
        ...state,
        preferences: {
          loaded: false,
          loading: true,
          error: null
        }
      };
    }
    case GET_PREFERENCES_SUCCESS: {
      return {
        ...state,
        preferences: {
          loaded: true,
          loading: false,
          error: action.error
        },
        settings: {
          ...action.data
        }
      };
    }
    case SAVE_PREFERENCES_ERROR: {
      return {
        ...state,
        savePreferences: {
          loaded: true,
          loading: false,
          error: action.error
        }
      };
    }
    case SAVE_PREFERENCES_INIT: {
      return {
        ...state,
        savePreferences: {
          loaded: false,
          loading: true,
          error: action.error
        }
      };
    }
    case SAVE_PREFERENCES_SUCCESS: {
      const returnObject = {
        ...state,
        savePreferences: {
          loaded: true,
          loading: false,
          error: action.error
        }
      };

      if (action.settings) {
        returnObject.settings = action.settings;
      }

      return returnObject;
    }
    case TOGGLE_INPUT: {
      return {
        ...state,
        settings: {
          ...state.settings,
          [action.data]: !state.settings[action.data]
        }
      };
    }
    case TOGGLE_ITEM: {
      return {
        ...state,
        settings: {
          ...state.settings,
          [action.input]: action.field
        }
      };
    }
    case GET_MARKETPLACE_MATCHES_START: {
      return {
        ...state,
        matches: {
          purchased: action.isNew ? null : action.purchased ? null : state.matches?.purchased,
          unpurchased: action.isNew ? null : action.purchased ? state.matches?.unpurchased : null,
          loading: true,
          purchasedLoaded: action.isNew ? false : action.purchased ? false : state.matches.purchasedLoaded,
          unpurchasedLoaded: action.isNew ? false : action.purchased ? state.matches.unpurchasedLoaded : false,
          status: null,
          error: null
        }
      };
    }
    case GET_MARKETPLACE_MATCHES_SUCCESS: {
      return {
        ...state,
        matches: {
          purchased: action.purchasedData || state.matches?.purchased,
          unpurchased: action.unpurchasedData || state.matches?.unpurchased,
          loading: false,
          purchasedLoaded: action.purchased ? true : state.matches.purchasedLoaded,
          unpurchasedLoaded: action.purchased ? state.matches.unpurchasedLoaded : true,
          status: action.status,
          error: null
        }
      };
    }
    case GET_MARKETPLACE_MATCHES_ERROR: {
      return {
        ...state,
        matches: {
          purchased: null,
          unpurchased: null,
          loading: false,
          purchasedLoaded: true,
          unpurchasedLoaded: true,
          status: action.status,
          error: action.message
        }
      };
    }
    case GET_SURVEY_DETAILS_START: {
      return {
        ...state,
        surveyDetails: {
          surveyJobs: action.surveyJobs || state.surveyDetails.surveyJobs,
          filteredSurveyJobs: action.filteredSurveyJobs || state.surveyDetails.filteredSurveyJobs,
          details: null,
          loading: true,
          loaded: false,
          status: null,
          error: null
        }
      };
    }
    case GET_SURVEY_DETAILS_SUCCESS: {
      return {
        ...state,
        surveyDetails: {
          surveyJobs: state.surveyDetails.surveyJobs,
          filteredSurveyJobs: state.surveyDetails.filteredSurveyJobs,
          details: action.data?.details,
          loading: false,
          loaded: true,
          status: action.data?.status,
          error: null
        }
      };
    }
    case GET_SURVEY_DETAILS_ERROR: {
      return {
        ...state,
        surveyDetails: {
          surveyJobs: state.surveyDetails.surveyJobs,
          filteredSurveyJobs: state.surveyDetails.filteredSurveyJobs,
          details: null,
          loading: false,
          loaded: true,
          status: action.data?.status,
          error: action.data?.message
        }
      };
    }
    case TOGGLE_ONLY_SHOW_FREQUENT: {
      return {
        ...state,
        settings: {
          ...state.settings,
          onlyShowFrequent: action.value
        }
      };
    }
    case PURCHASE_SUBMIT_START: {
      return {
        ...state,
        purchaseSubmit: {
          loading: true,
          success: false,
          error: null
        }
      };
    }
    case PURCHASE_SUBMIT_SUCCESS: {
      return {
        ...state,
        purchaseSubmit: {
          loading: false,
          success: true,
          error: null
        }
      };
    }
    case PURCHASE_SUBMIT_ERROR: {
      return {
        ...state,
        purchaseSubmit: {
          loading: false,
          success: false,
          error: action.error
        }
      };
    }
    case PURCHASE_SUBMIT_RESET: {
      return {
        ...state,
        purchaseSubmit: {
          loading: false,
          success: false,
          error: null
        }
      };
    }
    case RESET_MARKETPLACE_MATCHES: {
      return {
        ...initialState,
        settings: state.settings,
        slideout: state.slideout,
        geographies: state.geographies,
        industries: state.industries,
        preferences: state.preferences
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}

export default combineReducers({
  marketplaceMatchesReducer,
  marketplaceMatchesGridReducer: MarketplaceMatchesGridCreate
});
